'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SavedSearchForm;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseInlineOverlay = require('@bibliocommons/base-inline-overlay');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _newSavedSearch = require('../../new-saved-search');

var _newSavedSearch2 = _interopRequireDefault(_newSavedSearch);

var _duplicateSavedSearch = require('../../duplicate-saved-search');

var _duplicateSavedSearch2 = _interopRequireDefault(_duplicateSavedSearch);

require('../styles/SavedSearchForm.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SavedSearchForm(props) {
  return _react2.default.createElement(
    'div',
    { className: 'cp-saved-search-form', 'data-test-id': 'saved-search-form' },
    _react2.default.createElement(
      _baseInlineOverlay.InlineOverlay,
      { handleClose: props.closeWorkflow },
      _react2.default.createElement(
        _baseInlineOverlay.InlineOverlayHeader,
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'save_search' })
      ),
      _react2.default.createElement(
        _baseInlineOverlay.InlineOverlayBody,
        null,
        props.isDuplicate ? _react2.default.createElement(_duplicateSavedSearch2.default, {
          isSaving: props.isSaving,
          replaceSearch: props.replaceSearch,
          lastNameAttempt: props.lastNameAttempt,
          chooseNewName: props.chooseNewName }) : _react2.default.createElement(_newSavedSearch2.default, {
          isSaving: props.isSaving,
          saveSearch: props.saveSearch,
          searchQuery: props.searchQuery,
          fieldErrors: props.fieldErrors })
      )
    )
  );
}

SavedSearchForm.propTypes = {
  isSaving: _react.PropTypes.bool,
  isDuplicate: _react.PropTypes.bool,
  lastNameAttempt: _react.PropTypes.string,
  searchQuery: _react.PropTypes.string,
  saveSearch: _react.PropTypes.func.isRequired,
  chooseNewName: _react.PropTypes.func.isRequired,
  replaceSearch: _react.PropTypes.func.isRequired,
  closeWorkflow: _react.PropTypes.func.isRequired,
  fieldErrors: _reactImmutableProptypes2.default.map
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/saved-search/lib/components/saved-search-form/components/SavedSearchForm.component.js
// module id = 1466
// module chunks = 1